import PreviewTabs from './PreviewTabs';
export default PreviewTabs;
